import React from "react";
import { Carousel, CarouselItem, Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";

import { lastItem } from "../data/SHOWS";

import classes from "./css/CarouselHome.module.css";

import archive_carousel from "../assets/archive_carousel.jpg";
import nicasio from "../assets/nicasio_carousel.jpg";

const CarouselHome = () => {
  return (
    <Carousel className={classes.main} controls={false}>
      <CarouselItem>
        <Container>
          <Row className={classes.slide}>
            <Col className={classes.left_side}>
              <h1>Il mio Palcoscenico</h1>
            </Col>

            <Col className={classes.right_side}>
              <img src={nicasio} alt="carousel" />
              <div className={classes.info_internal}>
                <h4>LA MIA IDEA DI TEATRO</h4>
                {/* <h5>
                  Ciao sono Nicasio Anzelmo. Vieni a scoprire cos'è per me il
                  teatro!
                </h5> */}
              </div>
              <Link to="/about">Scopri di più</Link>
            </Col>
          </Row>
        </Container>
      </CarouselItem>

      <CarouselItem>
        <Container>
          <Row className={classes.slide}>
            <Col className={classes.left_side}>
              <h1>Ultimo spettacolo</h1>
            </Col>

            <Col className={classes.right_side}>
              <img src={lastItem.image_three} alt="carousel" />
              <div className={classes.info_internal}>
                <h4>{lastItem.title}</h4>
                <h5>
                  {lastItem.author} <br /> {lastItem.date}
                </h5>
              </div>
              <Link to="/shows">Vai agli Spettacoli</Link>
            </Col>
          </Row>
        </Container>
      </CarouselItem>

      <CarouselItem>
        <Container>
          <Row className={classes.slide}>
            <Col className={classes.left_side}>
              <h1>Visualizza l'archivio</h1>
            </Col>

            <Col className={classes.right_side}>
              <img src={archive_carousel} alt="carousel" />
              <div className={classes.info_internal}>
                <h4>LA MIA STORIA</h4>
                <h5>
                  Galleria spettacoli dal 1989 al 2014!
                </h5>
              </div>
              <Link to="/archive">Accedi all'archivio</Link>
            </Col>
          </Row>
        </Container>
      </CarouselItem>
    </Carousel>
  );
};

export default CarouselHome;
